import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent  {
  title = 'Angular-Interceptor';
  
  constructor(private router: Router,
    public dialogRef: MatDialogRef<ErrorDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) { }

 
  onSignIn(){   
    // this.router.navigate(['/login']); 
    
    this.data.result = true; 
    this.dialogRef.close('onSignIn');
    
  }

  onClose(event){
    // dialog is closing...
    // this.data.result = false;
  }
}
